/**
 * Invoice Ninja (https://invoiceninja.com).
 *
 * @copyright Copyright (c) 2022. Invoice Ninja LLC (https://invoiceninja.com)
 *
 * @copyright Copyright (c) 2022. Invoice Ninja LLC (https://invoiceninja.com)
 *
 * @license https://www.elastic.co/licensing/elastic-license
 */
export const enum RecurringInvoicesFrequency {
  FREQUENCY_DAILY = '1',
  FREQUENCY_WEEKLY = '2',
  FREQUENCY_TWO_WEEKS = '3',
  FREQUENCY_FOUR_WEEKS = '4',
  FREQUENCY_MONTHLY = '5',
  FREQUENCY_TWO_MONTHS = '6',
  FREQUENCY_THREE_MONTHS = '7',
  FREQUENCY_FOUR_MONTHS = '8',
  FREQUENCY_SIX_MONTHS = '9',
  FREQUENCY_ANNUALLY = '10',
  FREQUENCY_TWO_YEARS = '11',
  FREQUENCY_THREE_YEARS = '12',
  RECURS_INDEFINITELY = '-1',
}
